import React, { Component } from 'react';
import { Modal, Button, Row, Col } from 'react-bootstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../../../state/modals-dux';


class DeleteTagModal extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { openModal, closeModal, tagToDelete, handleDeleteTag, deleteTagInProgress } = this.props;
    return (
      <Modal show={openModal === 'DeleteTagModal'} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Tag</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!deleteTagInProgress && (
            <span>Are you sure you want to permanently delete tag {(tagToDelete || {}).value} and remove from {(tagToDelete || {}).assetCount} assets?</span>
          )}
          {deleteTagInProgress && (
            <span>Loading ...</span>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button type="button" bsStyle="default" onClick={closeModal} disabled={deleteTagInProgress}>
            <span className="ti ti-close" /> Cancel
          </Button>
          {' '}
          <Button type="button" bsStyle="primary" onClick={() => handleDeleteTag(tagToDelete)} disabled={deleteTagInProgress}>
            <span className="ti ti-check" /> Yes, Delete
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}


const mapState = state => ({ openModal: state.modals });
const mapDispatch = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapState, mapDispatch)(DeleteTagModal);



// WEBPACK FOOTER //
// ./src/components/routes/tags/DeleteTagModal.js